import { Tag, TagType } from '@lbcamden/lib-react';
import { FunctionComponent } from 'react';

import { useReferenceListDisplayValue } from '~/client/hooks/storeHooks';
import { PcfraStatus } from '~/common/types/people';

type Props = {
  status: PcfraStatus;
  /** @default 'None' */
  noStatusText?: string;
  reviewOverdue?: boolean;
};

const statusTagTypes: Record<PcfraStatus, TagType> = {
  [PcfraStatus.None]: 'muted',
  [PcfraStatus.Requested]: 'warning',
  [PcfraStatus.Unnecessary]: 'muted',
  [PcfraStatus.Necessary]: 'standard',
  [PcfraStatus.Drafting]: 'standard',
  [PcfraStatus.Submitted]: 'info',
  [PcfraStatus.Active]: 'success',
  [PcfraStatus.ReviewNeeded]: 'warning',
};

export const PcfraStatusTag: FunctionComponent<Props> = ({
  status,
  noStatusText = 'None',
  reviewOverdue,
}) => (
  <Tag data-testid="pcfra-status" $type={reviewOverdue ? 'error' : statusTagTypes[status]}>
    {useReferenceListDisplayValue()('PCFRA_STATUS', status) || noStatusText}
  </Tag>
);
